export const signup = {
  title: 'Demande de compte',
  username: {
    reset: "Effacer le nom d'utilisateur",
    label: "* Nom d'utilisateur (entre 3 et 64 caractères)",
    error: "Merci de saisir un nom d'utilisateur valide. Exemple : abc",
  },
  email: {
    reset: "Effacer l'email",
    label: '* Identifiant (email)',
    error: 'Merci de saisir un email valide. Exemple : pseudo@domaine.com',
  },
  password: {
    reset: 'Effacer le mot de passe',
    show: 'Afficher le mot de passe',
    hide: 'Masquer le mot de passe',
    label: '* Mot de passe',
    error: 'Merci de saisir un mot de passe...',
    wrong: 'Mot de passe erronné',
    security: 'Le mot de passe doit suivre les règles de sécurité.',
    rules: `
      Le mot de passe doit contenir entre {passwordMin} et {passwordMax} caractères, dont : au moins une lettre majuscule, au moins une lettre minuscule,
      au moins un chiffre, au moins un caractère spécial: {passwordAuthCar}
    `,
  },
  passwordConfirm: {
    reset: 'Effacer la confirmation du mot de passe',
    show: 'Afficher la confirmation du mot de passe',
    hide: 'Masquer la confirmation du mot de passe',
    label: '* Confirmation du mot de passe',
    error: 'Merci de saisir la confirmation du mot de passe...',
    wrong: 'Confirmation du mot de passe erronné',
    security:
      'La confirmation du mot de passe doit suivre les règles de sécurité.',
    rules: `
      Le mot de passe doit contenir entre {passwordMin} et {passwordMax} caractères, dont : au moins une lettre majuscule, au moins une lettre minuscule,
      au moins un chiffre, au moins un caractère spécial: {passwordAuthCar}
    `,
  },
  cgu: {
    firstWords: 'Pour que la demande de création soit effective, vous devez lire et accepter les ',
    linkLabel: 'Conditions Générales d\'Utilisation (CGU)',
    lastWords: ' fixées par ce site, incluant l\'utilisation des cookies.',
    title: 'Aller vers: Conditions Générales d\'Utilisation (CGU)',
    checkboxTitle: "J'ai bien lu les Conditions Générales d'Utilisation et je les accepte.",
    error: 'Vous devez accepter les CGU pour valider votre inscription.'
  },
  buttons: {
    cancel: {
      label: 'Annuler',
    },
    ok: {
      label: 'Valider la demande',
    },
  },
  msg: {
    technicalError:
      "Erreur technique (Code: {errorCode}).<br>Nombre d'essais restants : {rateLimitRemaining}.<br>Renouvellement le {rateLimitReset}",
    invalidProvidedData:
      "Données fournies incorrectes / invalides.<br>Nombre d'essais restants : {rateLimitRemaining}.<br>Renouvellement le {rateLimitReset}",
    SIGNUP_ERR_CSRF_01: 'Jeton CSRF invalide',
    SIGNUP_ERR_CSRF_02: 'Jeton CSRF inconnu',
    SIGNUP_ERR_04_1: 'Ce nom d\'utilisateur est déjà utilisé',
    SIGNUP_ERR_04_2: 'Cette adresse mail est déjà utilisée',
    SIGNUP_ERR_06: 'Vous devez accepter les mentions légales et les conditions d\'utilisation',
    SIGNUP_ERR_07: 'Erreur technique lors de l\'ajout de l\'utilisateur',
    SIGNUP_ERR_08: 'Erreur pendant l\'envoi de mail : le nom de domaine est introuvable',
    SIGNUP_ERR_09: 'Erreur technique pendant l\'envoi de mail. Raisons possibles : service indisponible, domaine de mail introuvable, ... Veuillez réessayer ultérieurement',
    SIGNUP_ERR_10: 'Erreur technique',

    success: 'Mail envoyé avec succès.',
  },
};
